/** Public home always uses Active Challenge, independently of the Central selection. */
export function inWindow(start: string, end: string, now: number): boolean {
  const from = Date.parse(start), to = Date.parse(end);
  return Number.isFinite(from) && Number.isFinite(to) && to >= from && now >= from && now <= to;
}
export function homeTiming(challenge: { ChallengeStartDate?: string; ChallengeEndDate?: string }, now: number) {
  const start = challenge && Date.parse(challenge.ChallengeStartDate);
  const end = challenge && Date.parse(challenge.ChallengeEndDate);
  const valid = !!challenge && Number.isFinite(start) && Number.isFinite(end) && end > start;
  const seconds = valid ? Math.max(0, Math.floor((start - now) / 1000)) : 0;
  // Calendar-day duration includes both boundary dates (37 for the 2026 holiday season).
  const calendarDate = (value: string) => Date.parse(value.slice(0, 10) + 'T00:00:00Z');
  const duration = valid ? Math.round((calendarDate(challenge.ChallengeEndDate) - calendarDate(challenge.ChallengeStartDate)) / 86400000) + 1 : 0;
  return { phase: !valid ? 'unknown' : now < start ? 'upcoming' : now < end ? 'active' : 'complete',
    duration, days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24,
    minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
}
